"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeader = exports.StyledContainer = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledContainer = (0, styles_1.styled)(material_1.Paper)(({ theme }) => ({
    margin: theme.spacing(0, 1),
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 165,
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.down("sm")]: {
        "min-width": "calc(100% - 16px)",
    },
}));
exports.StyledHeader = (0, styles_1.styled)(material_1.Typography)(({ theme }) => ({
    padding: 0,
    lineHeight: "28px",
    textTransform: "uppercase",
    fontWeight: 600,
    textAlign: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
}));
//# sourceMappingURL=styled.js.map